export function landingHash() {
  class LandingHash {
    constructor() {
      this.init();
    }

    init() {
      this.bodyScroll();
      this.currrentHash();
    }

    bodyScroll() {
      if(location.hash) {
        const target = document.querySelector(location.hash);
        if (target) {
          const targetPosition = target.getBoundingClientRect().top + window.scrollY - 100;
          setTimeout(() => {
            window.scrollTo({
              top: targetPosition,
              behavior: 'auto'
            });
          }, 100);
        }
      }
    }

    currrentHash() {
      const anchors = document.querySelectorAll('a');
      anchors.forEach(anchor => {
        anchor.addEventListener('click', (event) => {
          const target = (event.currentTarget as HTMLAnchorElement).getAttribute('href');
          // targetに#が含まれている場合
          if (target && target.includes('#')) {
            const pagePath = location.pathname;
            const targetId = target.split('#')[1];
            const targetUrl = target.split('#')[0];
            if (targetUrl === pagePath) {
              event.preventDefault();
              const targetElement = document.getElementById(targetId);
              if (targetElement) {
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 100;
                setTimeout(() => {
                  window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                  });
                }, 100);
              }
            } else {
              return;
            }
          }
        });
      });
    }
  }

  new LandingHash();
}